import React from "react";
import { CrossIconSVG } from "modules/icons";
import useStyles from "./styles";

export const CrossIcon: React.FC = () => {
  const { classes } = useStyles();
  return <CrossIconSVG className={classes.cross} />;
};
